import { render, staticRenderFns } from "./EditLeave.vue?vue&type=template&id=263e81e5&scoped=true&"
import script from "./EditLeave.vue?vue&type=script&lang=js&"
export * from "./EditLeave.vue?vue&type=script&lang=js&"
import style0 from "./EditLeave.vue?vue&type=style&index=0&id=263e81e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e81e5",
  null
  
)

export default component.exports